<script setup lang="ts">
import { MessageCard } from '@/components/Cards'
import type { EColors } from '@/types/constants/ColorValues'
import Markdown from 'vue3-markdown-it'
import { BaseDialog } from '.'

type Props = {
    text: string
    open: boolean
    fullLength?: boolean
    type?: EColors
}
defineProps<Props>()
</script>

<template>
    <BaseDialog :closeLabel="$t('common.close')" :open="open" noFooter class="show-more-dialog">
        <template #content>
            <MessageCard hasIcon :type="type">
                <Markdown :source="text" />
            </MessageCard>
        </template>
    </BaseDialog>
</template>

<style scoped lang="scss">
.show-more-dialog {
    & :deep(.card-content) {
        padding: unset;
        & .icon svg {
            height: unset;
        }
    }
}
</style>
